import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';

import sign_in_logo from '../../assets/images/sign_in_cover.png';
// add image
import sign_in_cover from '../../assets/images/vts1.jpg';
//api
import { authenticate } from './AuthSignInSlice';

const SignupSchema = yup.object().shape({
  usn: yup.string().required('Username is a required field.'),
  pwd: yup
    .string()
    .required('Password is a required field.')
    .min(8, 'Password must be at least 8 characters.'),
});

const AuthSignIn = () => {
  const [passwordShown, setPasswordShown] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [remember, setRemember] = useState(true);
  const history = useHistory();

  const togglePasswordVisiblity = () => {
    setPasswordShown(!passwordShown);
  };

  const {
    register,
    resetField,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(SignupSchema),
  });

  const onSubmit = () => {
    const username = getValues('usn');
    const password = getValues('pwd');
    dispatch(authenticate({ username, password }));
    resetField('usn');
    resetField('pwd');
    history.push('');
  };

  return (
    <div>
      <div className="auth-wrapper">
        <div className="auth-content container">
          <div className="card">
            <div className="row align-items-center">
              <div className="col-md-5">
                <div className="card-body">
                  <img src={sign_in_logo} width="100%" />
                  <h4 className="mb-3">{t('login')}</h4>
                  <form
                    action="/signin"
                    method="post"
                    autoComplete={remember ? 'on' : 'off'}
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="feather icon-user"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        name="username"
                        className="form-control"
                        placeholder="Email"
                        {...register('usn')}
                      />
                    </div>
                    {errors.usn && (
                      <Alert
                        variant="danger"
                        style={{
                          padding: '5px',
                          height: '32px',
                          marginTop: '-8px',
                        }}
                      >
                        <p>{errors.usn.message}</p>
                      </Alert>
                    )}
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="feather icon-lock"></i>
                        </span>
                      </div>
                      <input
                        type={passwordShown ? 'text' : 'password'}
                        name="password"
                        className="form-control"
                        placeholder="Password"
                        {...register('pwd')}
                      />
                      <i
                        className={
                          !passwordShown
                            ? 'feather icon-eye-off'
                            : 'feather icon-eye'
                        }
                        onClick={togglePasswordVisiblity}
                      ></i>
                    </div>
                    {errors.pwd && (
                      <Alert
                        variant="danger"
                        style={{ padding: '5px', height: '32px' }}
                      >
                        <p>{errors.pwd.message}</p>
                      </Alert>
                    )}
                    <div className="form-group text-left mt-2">
                      <div
                        className="checkbox checkbox-primary d-inline"
                        style={{ opacity: '1' }}
                      >
                        <input
                          type="checkbox"
                          name="checkbox-fill-1"
                          id="checkbox-fill-a1"
                          onChange={() => {
                            setRemember(!remember);
                          }}
                          checked={remember ? true : false}
                        />
                        <label htmlFor="checkbox-fill-a1" className="cr">
                          {' '}
                          {t('remember-me')}
                        </label>
                      </div>
                    </div>
                    <button className="btn btn-primary mb-4" type="submit">
                      {t('login')}
                    </button>
                  </form>
                </div>
              </div>
              <div className="col-md-7 d-none d-md-block">
                <img src={sign_in_cover} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-fab">
        <div className="b-bg">
          <i className="fas fa-question"></i>
        </div>
        <div className="fab-hover">
          <ul className="list-unstyled">
            <li>
              <a
                href="/introduction"
                target="_blank"
                data-text="Document"
                className="btn btn-icon btn-rounded btn-primary m-0"
              >
                <i className="feather icon feather icon-book"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AuthSignIn;
